__turbopack_context__.v({
  "backgroundImage": "nCgcva_backgroundImage",
  "blogLink": "nCgcva_blogLink",
  "card": "nCgcva_card",
  "category": "nCgcva_category",
  "double": "nCgcva_double",
  "fill": "nCgcva_fill",
  "hero": "nCgcva_hero",
  "heroImageFill": "nCgcva_heroImageFill",
  "imageCritical": "nCgcva_imageCritical",
  "inCarousel": "nCgcva_inCarousel",
  "metadata": "nCgcva_metadata",
  "single": "nCgcva_single",
  "text": "nCgcva_text",
  "triple": "nCgcva_triple",
});
